/** Microsoft Clarity session recording and heatmaps. */
export const CLARITY_PROJECT_ID = 'yb47vi0lzt'

const SCRIPT_SRC = `https://www.clarity.ms/tag/${CLARITY_PROJECT_ID}`

type Clarity = ((...args: unknown[]) => void) & { q?: unknown[][] }

interface ClarityWindow extends Window {
  clarity?: Clarity
}

/** Injects the Clarity tag once, into the document head. */
export function initClarity(): void {
  if (typeof window === 'undefined') return
  if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) return

  const w = window as ClarityWindow
  const clarity: Clarity =
    w.clarity ||
    (function (...args: unknown[]) {
      ;(clarity.q = clarity.q || []).push(args)
    } as Clarity)
  w.clarity = clarity

  const script = document.createElement('script')
  script.async = true
  script.src = SCRIPT_SRC
  document.head.appendChild(script)
}
